var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 91 91",
    enableBackground: "new 0 0 91 91",
    id: "Layer_1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.713,12.142H5.861c-2.305,0-4.174-1.869-4.174-4.176c0-2.305,1.869-4.174,4.174-4.174h79.852   c2.305,0,4.174,1.869,4.174,4.174C89.887,10.273,88.018,12.142,85.713,12.142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.713,49.858H5.861c-2.305,0-4.174-1.869-4.174-4.175c0-2.307,1.869-4.176,4.174-4.176h79.852   c2.305,0,4.174,1.869,4.174,4.176C89.887,47.989,88.018,49.858,85.713,49.858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.713,87.571H5.861c-2.305,0-4.174-1.869-4.174-4.176s1.869-4.176,4.174-4.176h79.852   c2.305,0,4.174,1.869,4.174,4.176S88.018,87.571,85.713,87.571z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.252b0b429391f20031584b404f391ddb.svg";
export { ForwardRef as ReactComponent };